<template>
  <div id="app">
    <app-inquire-floorplan :plan="plan" :filters="filters" :class="{active: inquireOpen}"></app-inquire-floorplan>

    <transition name="fade" mode="out-in">
      <component :soldUnits="soldUnits" :data="getData" :is="getCurrentComponent"></component>
    </transition>
    <app-model :soldUnits="soldUnits" :class="{active: activeComponent === 'app-floorplans'}" :currentComponent="activeComponent"></app-model>
    <div class="clear">

    </div>
    <div class="footer">
      <!-- normal -->
      <button class="back back-floorplan" @click="closePlan()" v-if="planOpen">
        <div class="arrow">
          <i class="icon-arrow-left icons"></i>
        </div>
        <div class="back_label">
          back to floor plans
        </div>
      </button>
      <!-- mobile only -->
      <!-- <button class="back back-floorplan mobile" @click="closeInquire()" v-if="inquireOpen">
        <div class="arrow">
          <i class="icon-arrow-left icons"></i>
        </div>
        <div class="back_label">
          back to floor plans
        </div>
      </button> -->
      <button class="back back-filters mobile" @click="restartFilter()" v-if="(!filtersOpened || filterIndex > 0) && !inquireOpen && !planOpen">
        <div class="arrow">
          <i class="icon-arrow-left icons"></i>
        </div>
        <div class="back_label">
          back to filters
        </div>
      </button>
      <img class="small_logo" alt="The Livmore - Refined Residential Rentals" role="img" :src="small_logo" :class="{backPresent: !filtersOpened || filterIndex > 0}"/>
    </div>

    <div id="landscapeDetection" :class="{ 'enabled': landscapeDetected, 'hidden': inquireOpen }">
      <span>This web app is best viewed in portrait for mobile devices.</span>
    </div>
  </div>
</template>

<script>
/* global $, io */

import EventBus from './EventBus';
import ModelComponent from './components/Model';
import FloorplansComponent from './sections/Floorplans';
import InquireComponent from './components/InquireFloorplan';

export default {
  name: 'App',
  components: {
    // 'app-menu': MenuComponent,
    'app-model': ModelComponent,
    'app-floorplans': FloorplansComponent,
    // 'app-location': LocationComponent,
    // 'app-amenities': AmenitiesComponent,
    'app-inquire-floorplan': InquireComponent,
  },
  data() {
    return {
      activeComponent: 'app-floorplans',
      appData: [],
      appLoaded: false,
      landscapeDetected: false,
      small_logo: 'static/img/landing/small_logo.png',
      planOpen: false,
      plan: null,
      filtersOpened: true,
      filterIndex: 0,
      inquireOpen: false,
      filters: '',
      ieDetected: false,
      socket: null,
      fp_avail: null,
      units: [],
      soldUnits: []
    };
  },
  methods: {
    setActivePage(activePage) {
      this.activeComponent = activePage;
      EventBus.$emit('closePlan');
      if (activePage === 'app-landing') {
        setTimeout(() => {
          $('#landing .left').addClass('active');
        }, 1000);
      }
    },
    startApplication(data) {
      console.log('Starting application...');
      this.appLoaded = true;
      this.appData = data;
    },
    goHome() {
    },
    openPlan() {
      this.planOpen = true;
    },
    closePlan() {
      this.planOpen = false;
      EventBus.$emit('closePlan');
      EventBus.$emit('toggleModel', true);
    },
    openInquire(plan, filters) {
      this.plan = plan;
      this.filters = filters;
      EventBus.$emit('inquireFloorplanOpen');
      this.inquireOpen = true;
    },
    closeInquire() {
      // console.log('close inquire');
      this.inquireOpen = false;
    },
    // Mobile filters
    filterStatus(opened, count) {
      // console.log('filter status', opened);
      this.filtersOpened = opened;
      this.filterIndex = count;
    },
    restartFilter() {
      EventBus.$emit('restartFilter');
    },
    msieversion() {
      const ua = window.navigator.userAgent;
      this.ieDetected = false;

      const msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        // return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        this.ieDetected = true;
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        // var rv = ua.indexOf('rv:');
        // return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        this.ieDetected = true;
      }

      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        // return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        this.ieDetected = true;
      }
    },
    checkOrientation() {
      if (!this.ieDetected) {
        const deviceOrientation = window.screen.orientation.angle;
        if (deviceOrientation === 0 || deviceOrientation === 180) {
          // document.getElementById('landscapeDetection').style.display = 'none';
          this.landscapeDetected = false;
        } else if ((deviceOrientation === 90 || deviceOrientation === 270) && window.innerWidth < 768) {
          // document.getElementById('landscapeDetection').style.display = 'block';
          this.landscapeDetected = true;
        } else {
          this.landscapeDetected = false;
        }
      }
      // console.log('device orientation?');
    },
    pcReady() {
      EventBus.$emit('pcReady');
    },
    buildSoldUnits() {
      this.soldUnits = [];
      this.holdUnits = [];
      const curAvail = this.fp_avail;
      // console.log(curAvail);
      for (let i = 0; i < curAvail.length; i += 1) {
        // var adjusted_block = self.availData[i].name.replace("BLOCK ", "");
        const stacks = curAvail[i].stacks;
        for (let j = 0; j < stacks.length; j += 1) {
          const units = stacks[j].units;
          for (let k = 0; k < units.length; k += 1) {
            const detachedUnit = {
              unit: units[k].name,
              status: units[k].status,
              id: units[k].id,
            };
            this.units.push(detachedUnit);
            if (units[k].status !== 'available') {
              this.soldUnits.push(detachedUnit);
            }
          }
        }
      }
      // console.log('soldUnit built', this.soldUnits);
      this.initSockets();
    },
    initSockets() {
      this.socket = io.connect('https://aws.adhocstudio.ca');
      this.socket.on('connect', () => {
        this.socket.emit('joinProject', 10);
        // console.log('connected to project', 10);
      });
      // this.socket.on('unitUpdate', this.updateSoldUnits);
      setInterval(this.pingSocket, 20000);
    },

    pingSocket() {
      this.socket.emit('clientPing');
    },
    updateSoldUnits(e) {
      // console.log('hey units changed', e);

      if (e.status === 'sold' || e.status === 'hold') {
        for (let i = 0; i < e.units.length; i += 1) {
          const unitString = e.units[i].toString();
          const foundUnit = this.soldUnits.find((unit) => unit.id.toString() === unitString);
          const unitRef = this.units.find((unit) => unit.id.toString() === unitString);
          unitRef.status = e.status;

          if (!foundUnit && unitRef) {
            // console.log('adding sold unit', unitRef);
            this.soldUnits.push(unitRef);
          }
        }
      } else if (e.status === 'available') {
        for (let j = 0; j < e.units.length; j += 1) {
          const unitString = e.units[j].toString();
          const foundUnit = this.soldUnits.find((unit) => unit.id.toString() === unitString);
          const unitRef = this.units.find((unit) => unit.id.toString() === unitString);
          unitRef.status = e.status;

          if (foundUnit && unitRef) {
            const index = this.soldUnits.indexOf(foundUnit);
            this.soldUnits.splice(index, 1);
          }
        }
      }
      // console.log('current sold units', this.soldUnits);
      EventBus.$emit('updatedSoldUnits');
      // self.floorplansPage.handleSoldUnit(e);
    },
  },
  computed: {
    getCurrentComponent() {
      let returnVal = null;
      if (this.activeComponent !== 'app-model' && this.activeComponent !== 'app-landing') {
        returnVal = this.activeComponent;
      } else {
        returnVal = '';
      }
      return returnVal;
    },
    getData() {
      return this.appData.find(section => {
        return section.section_type === this.activeComponent;
      });
    }
  },
  /* eslint-disable */
  created() {
    window.pcReady = this.pcReady;
    this.msieversion();

    $.fancybox.defaults.btnTpl.close = '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
      '</button>';

    // mobile checkbox init
    window.onload = function () {
      var checkboxes = document.querySelectorAll('[role="checkbox"]');
      for (var i = 0; i < checkboxes.length; i++) {
        var cb = new Checkbox(checkboxes[i]);
        cb.init();
      }
    };
  },
  mounted() {
    EventBus.$on('goHome', this.goHome);
    EventBus.$on('openPlan', this.openPlan);
    EventBus.$on('closePlanHome', this.closePlan);

    EventBus.$on('startApplication', this.startApplication);
    EventBus.$on('setActivePage', this.setActivePage);

    EventBus.$on('openInquire', this.openInquire);
    EventBus.$on('closeInquire', this.closeInquire);

    EventBus.$on('filterStatus', this.filterStatus);


    // this.$http.get('static/json/section_content.json')
    this.$http.get('https://adhocstudio.ca/feed/getSections.php?id=412')
    .then(res => {
      const data = res.data.section;
      Object.entries(data).forEach(entry => {
        const [index, sectionData] = entry;
        this.appData.push(sectionData);
      });

      // console.log(res, this.appData);
      // this.$http.get('https://adhocstudio.ca/feed/getCompleteFloorplans.php?id=407')
      this.$http.get('https://adhocstudio.ca/feed/getCompleteFloorplans.php?id=412')
      .then(plansRes => {
        this.appData.find(section => section.section_name === 'floorplans').plans = plansRes.data.plans;

        let fp_avail_url = 'https://aws.adhocstudio.ca/api/floorplans/public/10';
        this.$http.get(fp_avail_url)
        .then(response => {
          this.fp_avail = response.data;
          EventBus.$emit('dataReady');
          this.buildSoldUnits();
        });

      });
    });

    window.addEventListener('onorientationchange', this.checkOrientation);
    window.addEventListener('resize', this.checkOrientation);

    this.checkOrientation();
  }
  /* eslint-enable */
};
</script>

<style lang="scss">
@import "./globals.scss";

@font-face {
  font-family: "ChronicleDeck";
  src: url("../static/fonts/ChronicleDeck-Roman.otf"); /* IE9 Compat Modes */
  src: url('../static/fonts/ChronicleDeck-Roman.eot'); /* IE9 Compat Modes */
  src: url('../static/fonts/ChronicleDeck-Roman.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('../static/fonts/ChronicleDeck-Roman.woff2') format('woff2'), /* Super Modern Browsers */
  url('../static/fonts/ChronicleDeck-Roman.woff') format('woff'), /* Pretty Modern Browsers */
  url('../static/fonts/ChronicleDeck-Roman.ttf')  format('truetype'); /* Safari, Android, iOS */
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "ChronicleDeck";
  // src: url("../static/fonts/ChronicleDeck-Semi.otf"); /* IE9 Compat Modes */
  src: url('../static/fonts/ChronicleDeck-Semi.eot'); /* IE9 Compat Modes */
  src: url('../static/fonts/ChronicleDeck-Semi.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('../static/fonts/ChronicleDeck-Semi.woff2') format('woff2'), /* Super Modern Browsers */
  url('../static/fonts/ChronicleDeck-Semi.woff') format('woff'), /* Pretty Modern Browsers */
  url('../static/fonts/ChronicleDeck-Semi.ttf')  format('truetype'); /* Safari, Android, iOS */
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Lato-Regular";
  src: url("../static/fonts/Lato-Regular.ttf"); /* IE9 Compat Modes */
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Lato-Regular";
  src: url("../static/fonts/Lato-Bold.ttf"); /* IE9 Compat Modes */
  font-weight: 700;
  font-style: normal;
}

body {
  margin: 0px;
  overflow: hidden;
  background-color: $livmoreBeige;
}

#app {
  font-family: $chronicleDeck, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  margin-bottom: 75px;

  #landscapeDetection {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    z-index: 99999;
    height: 100vh;
    width: 100vw;
    background: $livmoreBeige;
    color: $livmoreBlack;

    align-items: center;
    justify-content: center;

    &.enabled {
      display: flex;
    }

    &.hidden {
      display: none !important;
    }
  }
}

@media screen and (min-width: 1281px) and (orientation: landscape) {
  #app {
    margin-bottom: 75px;
  }
}
@media screen and (max-width: 1024px) {
}
@media screen and (max-width: 768px) {
}
@media screen and (max-width: 767px) {
  #app {
    margin-bottom: 75px;

    // min-height: 500px;
  }
}

@media screen and (orientation: landscape)
and (max-width: 991px) {
  #app {
    #landscapeDetection {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue